import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Lms } from 'app/shared/models/lms';
import { StrapiApiService } from 'app/shared/services/strapi-api.service';
import { id } from '@swimlane/ngx-charts';
import _ from 'core-js/fn/_';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-course-edit',
  templateUrl: './course-edit.component.html',
  styleUrls: ['./course-edit.component.scss',
  '../../../../../../assets/sass/pages/page-users.scss',
  '../../../../../../assets/sass/libs/select.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CourseEditComponent implements OnInit {
  @ViewChild('fileInput') myInputVariable: ElementRef;
  courseId:any;
  courseData={
    title:'',
    about:'',
    preliminary:'',
    total_fees:'',
    benifits:'',
    variations:{_id:''},
    course_tags:{_id:''},
    course_category:{_id:''},
    course_skills:[],
    lsm_ids:[],
    batch_ids:[],
    announcements:'',  
    notes:'',
    admin_notes:'',
    image:'',
    minfees:'',
    maxfees:'',
    objective:'',
    outcome:'',
    learning_audience:'',
    language:'',
    version:'',
    published_datetime:'',
    serviceandoffer:'',
    course_type:'',
    instructor:[],
    proofreaders:[],
    publishers:[],
    projects:[],
    resources:[],
    last_published_by:'',
    duration:'',
    offers:[],
    category:[],
    level:'',
    published_web:'',
    published_app:'',
    mode:[],
    promotional_video:'',
    grading:'',
    certification:''
  };
  resetFile=""
  selectedValue:'';
  imageUrl=environment.apiUrls.course_imageUrl;

  fileData:File;
  imgUrl:any;
  tags=[];
  selectedLms:string[]=[];
  batchList=[];
  selectedTag:string[]=[];
  selectedCategory=null
  categoryList=[]
  tagsList=[];
  selectedBatch:any='';
  variationList:[];
  selectedVariation=null
  courseTagsList=[];
  selectedCourseTag=null
  catId='6319d5025ab9e462a96cfbba'
  skillId='6319d3595ab9e462a96cfb06'
  durationId='631ad5d2ce5c666542591b40'
  courseTagId='631ad5b3ce5c666542591b3c'
  variationId='6532279427098beed312fab4'
  lmsData:[];
  
  category_tags_list =[]
  selected_category_tags = null

  
  course_type_List =[
    {displayname:'Internal',_id:'internal'},
    {displayname:'External',_id:'external'},
  ]
  selected_course_type =null
  level_List =[
    {displayname:'Beginner',_id:'beginner'},
    {displayname:'Intermediate',_id:'intermediate'},
    {displayname:'Advanced',_id:'advanced'}
  ]
  selected_level =null
  mode_List =[
    {displayname:'Online',_id:'online'},
    {displayname:'Offline',_id:'offline'},
  ]
  // selected_mode :string[]=[]
  selected_mode =null
  publish_List =[
    {displayname:'True',_id:true},
    {displayname:'False',_id:false},
  ]
  selected_publish_web =null
  selected_publish_app =null
  fullpart_employee_list=[]
  selected_instructor =null
  selected_proofread=null
  selected_publisher=null
  selected_last_publisher = null
  project_list=[]
  workon_id='644a5c52af0db342c32eeaf8'
  selected_project = null
  resource_list=[]
  selected_resource=null
  offers_list=[]
  selected_discount=null
  duration_List =[]
  selected_duration=null

  constructor(private activatedroute:ActivatedRoute,
    private strapiService: StrapiApiService,
    public toastr: ToastrService,
    private route:Router,public apiService:ApiService) { 
      this.getAllTags()
    }

  ngOnInit(): void {
    this.activatedroute.paramMap.subscribe(params => { 
    this.courseId = params.get('id'); 
    this.getCourseById()
  }),
  this.getTagByCategory()
    this.getSkillTagByCategory()
    this.getBatchTagBycategory()
    this.getDurationTagByCategory()
    this.getVariationTagByCategory()
    this.getCourseTagByCategory()
    this.getLmsV1()
    this.getFullPartEmployee()
    this.getProjectList()
    this.getResourceList()
    this.getOfferslist()

}
getFullPartEmployee(){
  this.apiService.getFullPartEmployeeList(1,100).subscribe((res:any)=>{
    this.fullpart_employee_list = res?.items
  })
}
getProjectList(){
  this.apiService.getJobsByStatus('6428038677a2ab2fb559dc36',1,100,this.workon_id,'current').subscribe((res:any)=>{
    this.project_list=res.data.items
  })
}
getResourceList() {
  this.apiService.getResourceList( 1, 100).subscribe((res: any) => {
    this.resource_list = res?.items
  })
}
getOfferslist(){
  this.apiService.getLeadsStatusList("offers_category").subscribe((res: any) => {
    this.offers_list = res?.data
  })
}
getAllTags(){
  this.apiService.getTagsList(1,500).subscribe((res:any)=>{
    this.category_tags_list = res?.data?.items
  })
}
getCategoryTagsId(event){
  this.selected_category_tags
}
getLmsV1() {
  this.strapiService.getLmsV1('').subscribe((res: any) => {
    this.lmsData = res;
  })
}
getLmsV1ById(event:any){
  this.selectedLms
}
getTagByCategory(){
  this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res:any)=>{
    this.categoryList=res.data
  })
 }
 getCategoryId(event:any){
  this.selectedCategory
 }
 getSkillTagByCategory(){
  this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res:any)=>{
    this.tagsList=res.data
  })
 }
 getTagsId(event:any){
  this.selectedTag
}
getBatchTagBycategory(){
  this.apiService.getBatchList(1,100).subscribe((res:any)=>{
    this.batchList=res?.data?.items
  })
 }
 getBatchId(event:any){
  this.selectedBatch
 }
  getDurationTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.durationId).subscribe((res:any)=>{
      this.duration_List=res.data
    })
   }
   getVariationTagByCategory(){
    this.apiService.getLeadsStatusList("course_variant").subscribe((res: any) => {
      this.variationList = res?.data
    })
   }
  getVariationId(event:any){
    this.selectedVariation
  }
  getCourseTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.courseTagId).subscribe((res:any)=>{
      this.courseTagsList=res.data
    })
  }
  getCourseTagId(event:any){
    this.selectedCourseTag
  }
// getTagsId(event:any){
//    this.selectedValue=event.target.value
//   console.log('selected tags id',this.selectedValue)
// }
getTagsList(){
  this.apiService.getTagsList(1,100).subscribe((res:any)=>{
    this.tags=res.data.items
  })
}

getCourseById(){
  this.apiService.getCourseById(this.courseId).subscribe((res:any)=>{
    this.courseData = res?.data[0]
    this.fileData =  res?.data[0]?.image
    // this.selectedValue=this.courseData?.tagsId[0]?._id
    if(res?.data[0]?.course_category){
      this.selectedCategory = res?.data[0]?.course_category[0]?._id
      this.courseData.course_category = this.selectedCategory
    }
    if(res?.data[0]?.course_tags){
      this.selectedCourseTag = res?.data[0]?.course_tags[0]?._id
      this.courseData.course_tags = this.selectedCourseTag
    }

    if(res?.data[0]?.variations){
      this.selectedVariation = res?.data[0]?.variations[0]?._id
      this.courseData.variations =  this.selectedVariation
    }
   
    if( res?.data[0]?.batch_ids != null){
      this.selectedBatch = res?.data[0]?.batch_ids[0]?._id
      this.courseData.batch_ids = this.selectedBatch
    }

    if(res?.data[0]?.course_skills){
      this.selectedTag = res?.data[0]?.course_skills?.map(item => item?._id)
      this.courseData.course_skills = this.selectedTag
    }
    if( res?.data[0]?.lsm_ids){
       this.selectedLms =  res?.data[0]?.lsm_ids?.map(item => item)
       this.courseData.lsm_ids = this.selectedLms
    }

    this.selected_course_type = res?.data[0]?.course_type
    this.courseData.course_type = this.selected_course_type
   
    if(res?.data[0]?.instructor){
      this.selected_instructor = res?.data[0]?.instructor[0]?._id
      this.courseData.instructor =  this.selected_instructor
    }
    if(res?.data[0]?.mode){
      this.selected_mode = res?.data[0]?.mode.map(item => item)
      this.courseData.mode =  this.selected_mode
    }
    if(res?.data[0]?.offers){
      this.selected_discount = res?.data[0]?.offers[0]?._id
      this.courseData.offers =  this.selected_discount
    }
    if(res?.data[0]?.proofreaders){
      this.selected_proofread = res?.data[0]?.proofreaders[0]?._id
      this.courseData.proofreaders =  this.selected_proofread
    }
    if(res?.data[0]?.projects){
      this.selected_project = res?.data[0]?.projects[0]?._id
      this.courseData.projects =  this.selected_project
    }
    if(res?.data[0]?.publishers){
      this.selected_publisher = res?.data[0]?.publishers[0]?._id
      this.courseData.publishers =  this.selected_publisher
    }
    if(res?.data[0]?.resources){
      this.selected_resource = res?.data[0]?.resources[0]?._id
      this.courseData.resources =  this.selected_resource
    }
    this.selected_publish_app = res?.data[0]?.published_app
    this.courseData.published_app = this.selected_publish_app

    this.selected_publish_web = res?.data[0]?.published_web
    this.courseData.published_web = this.selected_publish_web
    if(res?.data[0]?.duration){
      this.selected_duration = res?.data[0]?.duration[0]?._id
      this.courseData.duration = this.selected_duration
    }
    if( res?.data[0]?.last_published_by){
      this.selected_last_publisher = res?.data[0]?.last_published_by[0]?._id
      this.courseData.last_published_by = this.selected_last_publisher
    }  
    if( res?.data[0]?.category){
      this.selected_category_tags = res?.data[0]?.category[0]?._id
      this.courseData.category = this.selected_category_tags
    }  

    this.selected_level = res?.data[0]?.level
    this.courseData.level = this.selected_level

    // for(let item of this.courseData.lsm_ids){
    //    this.selectedLms.push(item)
     
    // }
    // this.selectedLms = this.selectedLms.map((item)=>item)
    // this.selectedLms
    // for(let item of this.courseData.course_category){
    //   this.selectedCategory.push(item._id)
    // }
    // this.selectedCategory = this.selectedCategory.map((item)=>item)
    // console.log('select category',this.selectedCategory)
    
  })
 
}
getBatchList(){
  this.apiService.getBatchList(1,100).subscribe((res:any)=>{
    this.batchList=res.data.items 
  })
 }
//  getBatchId(event:any){
//   console.log('batch',this.selectedBatch)
//  }
submit(){
  if(this.courseId){
    let formData=new FormData()
   
    for (let item of this.selectedTag){
      formData.append('course_skills[]',item)
    }
    for(let item of this.selectedLms){
      formData.append('lsm_ids[]',item)
    }
    this.courseData.batch_ids = this.selectedBatch
      
    // formData.append('title',this.courseData.title),
    // formData.append('about',this.courseData.about),
    // formData.append('preliminary',this.courseData.preliminary),
    // formData.append('total_fees',this.courseData.total_fees),
    // formData.append('benifits',this.courseData.benifits),
    // formData.append('announcements',this.courseData.announcements),
    //  formData.append('course_category',this.selectedCategory),
    // //  formData.append('course_skills',this.selectedTag),
    // formData.append('variations',this.selectedVariation),
    // formData.append('course_tags',this.selectedCourseTag),
    // formData.append('batch_ids',this.selectedBatch),
    //   // formData.append('lsm_ids',this.courseData.selectedLms),
    // formData.append('notes',this.courseData.notes),
    // formData.append('admin_notes',this.courseData.admin_notes),
    // formData.append('image',this.fileData),
    // formData.append('category',this.selected_category_tags),

    formData.append('title',this.courseData.title),
    formData.append('about',this.courseData.about),
    formData.append('preliminary',this.courseData.preliminary),
    formData.append('total_fees',this.courseData.total_fees),
    formData.append('benifits',this.courseData.benifits),
    formData.append('announcements',this.courseData.announcements),
    formData.append('course_category',this.selectedCategory),
    formData.append('variations',this.selectedVariation),
    formData.append('course_tags',this.selectedCourseTag),
    formData.append('batch_ids',this.selectedBatch),
    formData.append('notes',this.courseData.notes),
    formData.append('admin_notes',this.courseData.admin_notes),
    formData.append('course_type',this.selected_course_type),
    formData.append('instructor',this.selected_instructor),
    formData.append('proofreaders',this.selected_proofread),
    formData.append('publishers',this.selected_publisher),
    formData.append('projects',this.selected_project),
    formData.append('resources',this.selected_resource),
    formData.append('last_published_by',this.selected_last_publisher),
    formData.append('duration',this.selected_duration),
    formData.append('offers',this.selected_discount),
    formData.append('category',this.selected_category_tags),
    formData.append('level',this.selected_level),
    formData.append('published_web',this.selected_publish_web),
    formData.append('published_app',this.selected_publish_app),
    formData.append('mode',this.selected_mode),
    formData.append('minfees',this.courseData.minfees),
    formData.append('maxfees',this.courseData.maxfees),
    formData.append('objective',this.courseData.objective),
    formData.append('outcome',this.courseData.outcome),
    formData.append('learning_audience',this.courseData.learning_audience),
    formData.append('language',this.courseData.language),
    formData.append('version',this.courseData.version),
    formData.append('published_datetime',this.courseData.published_datetime),
    formData.append('serviceandoffer',this.courseData.serviceandoffer),
    formData.append('certification',this.courseData.certification),
    formData.append('grading',this.courseData.grading),
    formData.append('promotional_video',this.courseData.promotional_video),



    formData.append('image',this.fileData),


    this.apiService.updateCourse(this.courseId,formData).subscribe((res:any)=>{
      if(res.statusCode === 200){
         this.toastr.success('updated successfully',res.message)
      this.route.navigate(['/course/course-list'])
      }
      else{this.toastr.error(res.error)}  
    })
  }
  else{
    alert('Something went Wrong!!!')
  }
}
back(){
  this.route.navigate(['/course/course-list'])
}
onSelectFile(event:any){
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    this.fileData = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload=(event)=>{
      this.imgUrl=reader.result

      this.uploadImage()
    }
  }
}
uploadImage(){
  let formData = new FormData()
  formData.append('image',this.fileData)
  this.apiService.updateCourseImg(this.courseId,formData).subscribe((res:any)=>{
    if(res?.statusCode === 200){
      this.toastr.success('image uploaded successfull')
    }
    else this.toastr.error(res.error)
  })
}
resetImage(){
  this.imgUrl=''
  this.myInputVariable.nativeElement.value=null
  this.fileData=this.myInputVariable.nativeElement.files
}
getCourseTypeId(event){
  this.selected_course_type
  this.courseData.course_type = this.selected_course_type
}
getLevelId(event){
  this.selected_level
  this.courseData.level = this.selected_level
}
getModeId(event){
  this.selected_mode
  this.courseData.mode = this.selected_mode
  console.log(this.courseData.mode ,'mode')
}
getPublishWebId(event){
  this.selected_publish_web
  this.courseData.published_web = this.selected_publish_web
}
getPublishAppId(event){
  this.selected_publish_app
  this.courseData.published_app = this.selected_publish_app
}
getinstructorId(event){
  this.selected_instructor
  this.courseData.instructor = this.selected_instructor

}
getProofreadId(event){
  this.selected_proofread
  this.courseData.proofreaders = this.selected_proofread

}
getPublisherId(event){
  this.selected_publisher
  this.courseData.publishers = this.selected_publisher
}
getLastPublisherId(event){
  this.selected_last_publisher
  this.courseData.last_published_by = this.selected_last_publisher

}
getProjectId(event){
  this.selected_project
  this.courseData.projects = this.selected_project

}
getResourceId(event){
  this.selected_resource
  this.courseData.resources = this.selected_resource

}
getDiscountId(event){
  this.selected_discount
  this.courseData.offers = this.selected_discount

}
getDurationId(event){
  this.selected_duration
  this.courseData.duration = this.selected_duration

}


}